import { Modal, ModalBody, ModalContent } from "@heroui/react";
import { useBlockWaitingProgress } from "../../state/blockWaitingProgress";
import type { BridgeTxUnclaimedSuccess } from "../../state/types";
import { BlockWaitingProgress } from "../BlockWaitingProgress";
import { CountdownTimer } from "../CountdownTimer";
import { ClaimInfoCard } from "./ClaimInfoCard";
import { TransactionTypeChip } from "./TransactionTypeChip";

export function ClaimWaitingModal({
  isOpen,
  unclaimedTxData,
}: {
  isOpen: boolean;
  unclaimedTxData: BridgeTxUnclaimedSuccess | null;
}) {
  const blockWaitingProgress = useBlockWaitingProgress();

  if (!unclaimedTxData) {
    return null;
  }

  const isDeposit = unclaimedTxData.bridgeType === "deposit";

  return (
    <Modal
      isOpen={isOpen}
      size="lg"
      isDismissable={false}
      isKeyboardDismissDisabled={true}
      classNames={{
        base: "turnstile-modal-border rounded-3xl",
        closeButton: "text-white text-xl top-4 right-5",
        header: "pt-5 pb-3",
        body: "items-center p-6 pt-0 gap-4",
        backdrop: "turnstile-modal-backdrop",
      }}
    >
      <ModalContent>
        <ModalBody className="text-center p-8 space-y-4">
          <div>
            <CountdownTimer duration={15 * 60} />
          </div>
          <div className="space-y-2">
            <p className="font-semibold text-large">
              {isDeposit
                ? "Claiming tokens to Aztec..."
                : "Withdrawing to Ethereum..."}
            </p>
            <p className="text-small text-[#AEC4D3]">
              {blockWaitingProgress?.isWaiting
                ? "Waiting for L2 block to be available..."
                : "Confirm the claim transaction in your wallet."}
            </p>
          </div>
          {blockWaitingProgress?.isWaiting && (
            <BlockWaitingProgress
              currentBlock={blockWaitingProgress.currentBlock}
              targetBlock={blockWaitingProgress.targetBlock}
              label="Waiting for L1→L2 message"
            />
          )}
          <ClaimInfoCard
            amount={unclaimedTxData.amount}
            tokenDecimals={unclaimedTxData.tokenDecimals}
            tokenSymbol={unclaimedTxData.tokenSymbol}
          />
          <div className="flex items-center justify-between gap-2">
            <div className="font-semibold text-[#ADC0D0]">Transaction type:</div>
            <TransactionTypeChip type={isDeposit ? "private" : "public"} />
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
